import { paymentsV2MutationTypes } from '@/store/modules/payments_v2/types'
import { paymentSort } from '@/helpers/payment-sort.utils'

const mutations = {
    [paymentsV2MutationTypes.SET_PAYMENT_TYPES](state, types) {
        state.payment_types = Object.values(types)
    },
    [paymentsV2MutationTypes.SET_BANK_CODES](state, codes) {
        state.bank_codes = codes
    },
    [paymentsV2MutationTypes.ADD_PAYMENT]: (state, payment) => {
        state.payments = [...state.payments, payment]

        state.payments = paymentSort(state.payments)
    },
    [paymentsV2MutationTypes.UPDATE_PAYMENT]: (state, updatedPayment) => {
        state.payments = state.payments.map((payment) => {
            if (payment.local_id !== updatedPayment.local_id) return payment

            if (payment.payment_type !== updatedPayment.payment_type) {
                return { payment_type: payment.payment_type, ...updatedPayment }
            }

            return { ...payment, ...updatedPayment }
        })
    },
    [paymentsV2MutationTypes.SET_PAYMENT_DESCRIPTION]: (state, description) => {
        state.description = description
    },
    [paymentsV2MutationTypes.SET_VAT]: (state, includesVAT) => {
        state.includesVAT = includesVAT
    },

    [paymentsV2MutationTypes.REMOVE_PAYMENT]: (state, payment) => {
        if ([4, 5, 6, 7, 8, 10, 11, 100].includes(payment.payment_type)) {
            state.payments = state.payments.filter(
                (item) => item.sub_id !== payment.sub_id
            )

            return
        }

        state.payments = state.payments.filter(
            (item) => item.local_id !== payment.local_id
        )
    },
    [paymentsV2MutationTypes.SET_CLIENT](state, clientData) {
        state.client = {
            ...state.client,
            clientsName: clientData.name,
            optionalId: clientData.optionalId,
        }
    },
    [paymentsV2MutationTypes.SET_CLIENT_BY_WIG_ID](state, client) {
        state.client = {
            ...client,
            clientsName: `${client.first_name} ${client.last_name}`,
        }
    },
    [paymentsV2MutationTypes.SET_LOADING](state, loading) {
        state.loading = loading
    },
    [paymentsV2MutationTypes.SET_COMMENTS](state, comments) {
        state.comments = comments
    },
    [paymentsV2MutationTypes.SET_INVOICE_AND_RECEIPT](
        state,
        invoiceAndReceipt
    ) {
        state.invoiceAndReceipt = invoiceAndReceipt
    },
    [paymentsV2MutationTypes.RESET_STATE](state) {
        Object.assign(state, {
            payment_types: [],
            payments: [],
            bank_codes: [],
            description: '',
            client: {},
            loading: false,
            includesVAT: true,
            comments: {},
            invoiceAndReceipt: true,
        })
    },
}

export default mutations
